export const propertyTypesList = [
    { label: 'Leilighet', value: '1' },
    { label: 'Hytte/Feriehjem', value: '2' },
    { label: 'Faststående campingvogn', value: '12' },
    { label: 'Båt', value: '4' },
    { label: 'Campinghytte', value: '5' },
    { label: 'Enkeltrom', value: '6' },
    { label: 'Gård', value: '7' },
    { label: 'Hus', value: '8' },
    { label: 'Lavvo', value: '9' },
    { label: 'Rorbu', value: '10' },
    { label: 'Tretopphytte', value: '11' },
];

export const houseRulesList = [
    { label: 'Rullestolvennlig', value: 'wheelchairAccessible' },
    { label: 'Kjæledyr tillatt', value: 'petsAllowed' },
    { label: 'Røyking tillatt', value: 'smokingAllowed' },
];
